// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__1mac7","separator":"sidebar_separator__3DUp_","coming_soon_bold":"sidebar_coming_soon_bold__3GRTa"};